var ServerZone;
(function(ServerZone2) {
  ServerZone2["US"] = "US";
  ServerZone2["EU"] = "EU";
  ServerZone2["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));
export {
  ServerZone
};
//# sourceMappingURL=server-zone.js.map
